"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Typography = require("../Typography");
var _default = exports.default = {
  Price: (0, _Typography.StyledType)("span", {
    size: "display2",
    family: "pakt"
  })``,
  Override: (0, _Typography.StyledType)("span", {
    size: "linkCopy1",
    family: "nobel-bold"
  })``,
  Symbol: _styledComponents.default.span`
  `
};